import styled from 'styled-components';

const blue = '#0b1f82';
const blueDark = '#020f4d';
const cyan = '#4fcced';
const gray = '#a5a5a5';
const gray2 = '#d6d6d6';
const lightGray = '#f1f2f7';
const lighterGray = '#f9fafc';
const label = '#6f6f6f';
const red = '#d91a1a';
const yellow = '#b9790f';

export const RuleHead = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 14px;
    margin-bottom: 18px;
`;

export const RuleTitle = styled.h2`
    color: ${blue};
    font-family: "Open Sans", sans-serif;
    font-size: 22px;
    margin: 0;
`;

export const RuleMeta = styled.div`
    color: ${label};
    font-family: "Open Sans", sans-serif;
    font-size: 13px;
    margin-top: 6px;
`;

export const RuleActions = styled.div`
    display: flex;
    gap: 12px;
`;

export const Btn = styled.button`
    font-family: "Open Sans", sans-serif;
    border-radius: 30px;
    padding: 11px 22px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: ${(props) => (props.variant === 'border' ? '#fff' : blue)};
    color: ${(props) => (props.variant === 'border' ? blue : '#fff')};
    border: ${(props) => (props.variant === 'border' ? `2px solid ${blue}` : 'none')};

    &:hover {
        background: ${(props) => (props.variant === 'border' ? '#f0f8ff' : blueDark)};
    }

    &:disabled {
        background: ${gray};
        color: #fff;
        border: none;
        cursor: not-allowed;
    }
`;

export const FormGrid = styled.div`
    max-width: 660px;
    margin-top: 26px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const Hint = styled.div`
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    margin-top: 8px;
    color: ${(props) => (props.error ? red : props.overLimit ? yellow : label)};

    b {
        color: ${blue};
    }
`;

export const Field = styled.div`
    margin-bottom: 14px;

    label {
        display: block;
        font-family: "Open Sans", sans-serif;
        font-weight: 600;
        font-size: 13px;
        margin-bottom: 6px;
        color: #333;
    }

    input {
        width: 100%;
        border: 1px solid ${gray2};
        border-radius: 6px;
        padding: 11px;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        background: ${lighterGray};
        box-sizing: border-box;
    }

    input:focus {
        outline: none;
        border-color: ${blue};
        background: #e8f3f9;
    }

    /* react-datepicker */
    .react-datepicker-wrapper {
        width: 100%;
    }
`;

export const Row2 = styled.div`
    display: flex;
    gap: 12px;

    ${Field} {
        flex: 1;
    }
`;

export const CeBox = styled.div`
    border: 1px solid ${gray2};
    border-radius: 10px;
    background: #fff;
    margin: 8px 0 18px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

export const CeHead = styled.div`
    display: flex;
    align-items: center;
    gap: 9px;
    background: ${lightGray};
    color: ${blue};
    font-family: "Open Sans", sans-serif;
    font-weight: 700;
    font-size: 15px;
    padding: 13px 18px;
    border-bottom: 1px solid ${gray2};
`;

export const CeBody = styled.div`
    padding: 18px;
`;

export const CeSection = styled.div`
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: ${label};
    margin: 6px 0 10px;
`;

export const SelectWrap = styled.div`
    position: relative;

    select {
        width: 100%;
        appearance: none;
        -webkit-appearance: none;
        border: 1px solid ${gray2};
        border-radius: 6px;
        padding: 11px 38px 11px 12px;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        background: ${lighterGray};
        color: #333;
        cursor: pointer;
        box-sizing: border-box;
    }

    select:disabled {
        color: ${gray};
        cursor: not-allowed;
    }

    select:focus {
        outline: none;
        border-color: ${blue};
        background: #e8f3f9;
    }

    .selectwrap-chevron {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: ${gray};
        pointer-events: none;
    }
`;

export const Baseline = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    background: #eef6fb;
    border: 1px solid #bfe3f1;
    border-left: 4px solid ${cyan};
    border-radius: 8px;
    padding: 12px 16px;
    margin-top: 4px;

    .baseline-icon {
        color: ${blue};
        font-size: 24px;
    }
`;

export const BaselineTitle = styled.div`
    font-family: "Open Sans", sans-serif;
    font-weight: 700;
    color: ${blue};
    font-size: 13px;
`;

export const BaselineSub = styled.div`
    font-family: "Open Sans", sans-serif;
    font-size: 13px;
    color: #444;
    margin-top: 1px;

    .baseline-uuid {
        font-family: monospace;
        font-size: 12px;
        color: ${label};
        margin-left: 6px;
    }
`;

export const DatePickerInput = styled.input`
    width: 100%;
    border: 1px solid ${gray2};
    border-radius: 6px;
    padding: 11px;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    background: ${lighterGray};
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: ${blue};
        background: #e8f3f9;
    }
`;
